export default "__VITE_ASSET__DbctlDIg__"